import { render, staticRenderFns } from "./Seo.vue?vue&type=template&id=271371bc&"
import script from "./Seo.vue?vue&type=script&lang=js&"
export * from "./Seo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\laravel\\rawal\\rawal-laravel\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('271371bc')) {
      api.createRecord('271371bc', component.options)
    } else {
      api.reload('271371bc', component.options)
    }
    module.hot.accept("./Seo.vue?vue&type=template&id=271371bc&", function () {
      api.rerender('271371bc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/admin/product/Seo.vue"
export default component.exports